
let localShowPopup = localStorage.getItem('localShowPopup') || null;
if (localShowPopup == null || localShowPopup == 'true') {
  let showPopup = sessionStorage.getItem('showPopup') || null;

  if (showPopup == null) {
    let popup = document.querySelector('.age-popup');
    if(popup) {
      setTimeout(function() {
        popup.classList.add('popup--is-active');
        document.body.style.overflow = 'hidden';
        document.querySelectorAll(".input__year")[2].focus();
      }, 500);
      const inputYear = document.querySelectorAll(".input__year");
      for (var i = 0; i < inputYear.length; i++) {
        inputYear[i].addEventListener('keyup', function(event) {
          var maxlength = this.getAttribute('maxlength');
          if (this.value.length === parseInt(maxlength)) {
            var next = this.nextElementSibling;
            if (next !== null) {
              next.focus();
              next.value = "";
            }
          }
          if (event.keyCode === 8 || event.keyCode == 46 || event.code === 'Delete' || event.key === 'Delete' ) {
            var previous = this.previousElementSibling;
              previous.focus();
              previous.value = '';
          }
        });
      }
      inputYear[3].addEventListener('keyup', function() {
        setTimeout(function() {
          checkAge();
        }, 300)
      });
      // inputYear[3].addEventListener('input', function() {
      //   checkAge();
      // });
      document.addEventListener("keyup", (e) => {
        if (e.key === "Enter" ) {
          e.preventDefault();
          checkAge();
        }
      })

      function checkAge() {
        let year = '';
        document.querySelectorAll(".input__year").forEach((elm) => {
          year += elm.value;
        });

        if (year.length > 3) {
          let todayDate = new Date();
          let todayYear = todayDate.getFullYear();
          let age = todayYear - year;
          if (age > 17 ) {
            document.querySelector(".age-popup").style.display = "none";
            document.body.style.overflow = 'scroll';
            if (document.querySelector(".age-popup-checkbox").checked) {
              sessionStorage.setItem("showPopup", false)
              localStorage.setItem("localShowPopup", false)
            } else {
              sessionStorage.setItem("showPopup", true)
              localStorage.setItem("localShowPopup", true)
            }
          } else {
            document.querySelector(".popup-empty").style.display = "none";
            document.querySelector(".popup-failed").style.display = "block";
          }
        }
      }
    }
  }
}